import React from 'react';
import cx from 'classnames';
import Actions from './components/Actions';
import Description from './components/Description';
import Icon from './components/Icon';
import Image from './components/Image';
import PrimaryButton from './components/PrimaryButton';
import SecondaryButton from './components/SecondaryButton';
import Title from './components/Title';
import { EmptyStateContext } from './context';
import styles from './EmptyState.module.scss';
const EmptyState = ({ children, className, width = 'narrow', size = 'md', ...props }) => {
    const value = React.useMemo(() => ({ width, size }), [width, size]);
    return (React.createElement(EmptyStateContext.Provider, { value: value },
        React.createElement("div", { ...props, className: cx(styles.emptyStateWrapper, styles[`width-${width}`], styles[`size-${size}`]) },
            React.createElement("div", { className: styles.container }, children))));
};
EmptyState.Icon = Icon;
EmptyState.Description = Description;
EmptyState.Title = Title;
EmptyState.PrimaryButton = PrimaryButton;
EmptyState.SecondaryButton = SecondaryButton;
EmptyState.Actions = Actions;
EmptyState.Image = Image;
export default EmptyState;
